import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";

import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";

import moment from "moment";
import TablaDetallesAprobaciones from "./tablaDetallesAprobaciones";
import {
  DangerButton,
  InfoButton,
  SuccessButton,
} from "../../ui/buttons/Button";
import { Input, SearchInput, Textarea } from "../../ui/inputs/Input";

export const AprobarCompromisos = (props) => {
  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const idusuario = JSON.parse(localStorage.getItem("idusuario"));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));

  const [activate, setActivate] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [activo, setActivo] = useState(true);
  const [operacion, setOperacion] = useState(0);
  const [datospre, setDatospre] = useState([]);
  const [valida, setValida] = useState([]);
  const [depart, setDepart] = useState(null);
  const [tip, setTip] = useState(null);
  const [ticomp, setTicomp] = useState(null);
  const [ubi, setUbi] = useState(null);
  const [pucc, setPucc] = useState(0);
  const [tituloapro, setTituloapro] = useState("");
  const [data, setData] = useState([]);
  const [body, setBody] = useState(null);
  const [codigo, setCodigo] = useState(0);
  const [titulo, setTitulo] = useState("");
  const [chek, setChek] = useState(0);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [values, setValues] = useState({
    idcuenta: "",
    auxiliar: "",
    descripcionaux: "",
    idcategoriaprogramatica: "",
    idpuc: "",
    puc: "",
    categoria: "",
    disponibilidad: 0.0,
    montoinicial: 0.0,
    tipopartida: "",
  });
  const txtFecha = useRef();
  const txtFechaAprobacion = useRef();
  const txtObservacion = useRef();
  const txtNp = useRef();
  const txtCodigo = useRef();

  const onChange = (event) => {
    if (
      event.target.name === "descriaux" ||
      event.target.name === "ubicacion" ||
      event.target.name === "observacion"
    ) {
      event.target.value = event.target.value.toUpperCase();
    }
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtFecha.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Fecha",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    } else if (txtObservacion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Describa la Observación",
        icono: "informacion",
      });
      sigue = false;
      txtObservacion.current.focus();
    } else if (valida === 0) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar las Solicitudes",
        icono: "informacion",
      });
      sigue = false;
    } else if (sigue) {
      let datos = [];
      let datost = [];
      let validad = [];

      if (operacion === 1) {
        datos.push({
          nid: 0,
          fec: txtFecha.current.value,
          obser: txtObservacion.current.value.trim(),
          tip: parseInt(ticomp),
          depart: parseInt(depart),
          idefi: idefiscal,
          devol: tip,
          aprob: true,
        });

        for (let e = 0; e < data.length; e++) {
          datost.push({
            nid: data[e].idaprobacionesdetalle,
            motiv: data[e].motivo,
            idorden: data[e].idordenpago,
            conce: data[e].concepto,
            idapro: 0,
            tip: parseInt(data[e].tipo),
          });
        }

        for (let i = 0; i < data.length; i++) {
          validad.push({
            idordencs: data[i].idordenpago,
            idefis: idefiscal,
            val: data[i].val,
            tipocom: parseInt(ticomp),
            tipo: tip,
            validaparam: data[i].validaparam,
          });
        }
      }

      setBody({
        operacion: operacion,
        aprobaciones: datos,
        aprobdetalles: datost,
        spiritu: espiritu,
        valida: validad,
        ubi: props.ubica,
      });
      console.log(datos);

      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de " + (props.tipo === 0 ? "Desaprobar" : "Aprobar") +  " estos Documentos?.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/presupuesto/crearaprobaciones`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Solicitud Aprobada Correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const blanquear = () => {
    setValues({
      idcuenta: "",
      auxiliar: "",
      descripcionaux: "",
      idcategoriaprogramatica: "",
      idpuc: "",
      puc: "",
      categoria: "",
      disponibilidad: 0.0,
      montoinicial: 0.0,
      tipopartida: "",
    });
    setDatospre([]);
    setActivate(false);
    setChek(0);
    setValida([]);
    setDepart(null);
    setTip(null);
    setUbi(null);
    setPucc(0);
    setData([]);
    setTicomp(null);
    setBody(null);
    setCodigo(0);
    setTituloapro("");
    setTitulo("");
    setActivo(true);
  };

  const handleCloseSi = () => {
    if (operacion === 1) {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      Actualizar();
    }
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideRenderizar();
    props.onHideCancelar();
    blanquear();
  };

  const BaseDatos = (data) => {
    if (data.length > 0) {
      setActivo(false);
      setValida(1);
    } else {
      setActivo(true);
      setValida(0);
    }
    setData(data);
    console.log(data);
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        if (props.operacion !== 1) {
          setValues(props.aprobaciones);
          setDatospre(props.aprodetalle);
          let definic;
          let env;

          if (props.ubica === 40 && props.tipocom === 0) {
            if (props.tipo === 0) {
              definic = "Devuelto";
            } else {
              definic = "Enviado";
            }

            if (props.aprobado === true) {
              setTituloapro(
                <p className="text-success text-center">
                  ¡ El Documento ya fué {definic} a Administración !
                </p>
              );
            } else if (props.aprobado === false) {
              if (props.tipo === 0) {
                setTituloapro(
                  <p className="text-amber text-center">
                    ¡ El Documento esta por Devolver a Compras !
                  </p>
                );
              } else {
                setTituloapro(
                  <p className="text-amber text-center">
                    ¡ El Documento esta por Enviar a Administración !
                  </p>
                );
              }
            }
            setTitulo("Presupuesto - Solicitud de Compromiso [Consulta]");
          } else if (props.ubica === 90) {
            if (props.tipo === 0) {
              definic = "Devuelto";
            } else {
              definic = "Enviado";
            }

            if (props.aprobado === true) {
              setTituloapro(
                <p className="text-success text-center">
                  ¡ El Documento fué {definic} a Compras !
                </p>
              );
            }
            setTitulo(
              "Presupuesto - Orden de Pago (Imputacioón Aprobada) a Division de Compras [Consulta]"
            );
          } else if (props.devolver === 1) {
            if (props.tipo === 0) {
              definic = "Devuelto";
              env = "Devolver";
            } else {
              definic = "Enviado";
              env = "Enviar";
            }

            if (props.ubica === 40 && props.tipocom === 2) {
              if (props.aprobado === true) {
                if (props.tipo === 0) {
                  setTituloapro(
                    <p className="text-success text-center">
                      ¡ El Documento ya Fué {definic} a Compras !
                    </p>
                  );
                } else {
                  setTituloapro(
                    <p className="text-amber text-center">
                      ¡ El Documento ya Fué {definic} a Administración !
                    </p>
                  );
                }
              }
              setTitulo("Presupuesto - Solicitud de Compras [Consulta]");
            } else if (props.ubica === 59 && props.tipocom === 2) {
              if (props.aprobado === true) {
                setTituloapro(
                  <p className="text-success text-center">
                    ¡ El Documento esta por{" "}
                    {props.tipo === 0 ? "Devolver" : "Enviar"} a Administración
                    !
                  </p>
                );
              } else if (props.aprobado === false) {
                setTituloapro(
                  <p className="text-amber text-center">
                    ¡ El Documento ya Fué {definic} a Administración !
                  </p>
                );
              }
              setTitulo(
                "Presupuesto - Solicitud de Compras/Servicios [Consulta]"
              );
            } else if (props.ubica === 40 && props.tipocom === 3) {
              if (props.aprobado === true) {
                if (props.tipo === 0) {
                  setTituloapro(
                    <p className="text-success text-center">
                      ¡ El Documento ya Fué {definic} al Dto. Ingeniería !
                    </p>
                  );
                } else {
                  setTituloapro(
                    <p className="text-amber text-center">
                      ¡ El Documento ya Fué {definic} a Administración !
                    </p>
                  );
                }
              }
              setTitulo(
                "Unidad de Administración - Devolver Solicitud de Pago [Consulta]"
              );
            } else if (props.ubica === 95 && props.tipocom === 7) {
              if (props.aprobado === true) {
                setTituloapro(
                  <p className="text-success text-center">
                    ¡ El Documento ya Fué {definic} a Presupuesto !
                  </p>
                );
              } else if (props.aprobado === false) {
                setTituloapro(
                  <p className="text-amber text-center">
                    ¡ El Documento esta por {env} a Despacho !
                  </p>
                );
              }

              if (props.tipo === 1) {
                setTitulo("Despacho - Solicitud de Donación [Consulta]");
              } else {
                setTitulo("Presupuesto - Solicitud de Donación [Consultar]");
              }
            }
          }
        } else {
          txtObservacion.current.value = "";
          txtFecha.current.value = moment.utc(fechaSistema).format("YYYY-MM-DD");
          txtCodigo.current.value = "";

          let definic;

          if (props.ubica === 40 && props.tipocom === 0) {
            if (props.tipo === 0) {
              definic = "Devolver";
            } else {
              definic = "Enviar";
            }
            setDepart(1);
            setTip(props.tipo);
            setTicomp(props.tipocom);
            setTitulo("Presupuesto - " + definic + " Compromiso");
          } else if (props.ubica === 90) {
            if (props.tipo === 0) {
              definic = "Devolver";
            } else {
              definic = "Enviar";
            }
            setDepart(1);
            setTip(props.tipo);
            setTicomp(props.tipocom);
            setTitulo(
              "Presupuesto - " +
                definic +
                " Orden de Pago (Imputacioón Aprobada) a Division de Compras"
            );
          } else if (props.devolver === 1) {
            if (props.tipo === 0) {
              definic = "Devolver";
            } else {
              definic = "Enviar";
            }

            if (props.ubica === 40 && props.tipocom === 2) {
              setDepart(1);
              setTip(props.tipo);
              setTicomp(props.tipocom);
              setTitulo(
                "Presupuesto - " + definic + " Solicitud de Compras/Servicios"
              );
            } else if (props.ubica === 59 && props.tipocom === 2) {
              setDepart(9);
              setTip(props.tipo);
              setTicomp(props.tipocom);
              setTitulo(
                "Presupuesto - " + definic + " Solicitud de Compras/Servicios"
              );
            } else if (props.ubica === 40 && props.tipocom === 3) {
              setDepart(1);
              setTip(props.tipo);
              setTicomp(props.tipocom);
              setTitulo(
                "Unidad de Administración - " + definic + " Solicitud de Pago"
              );
            } else if (props.ubica === 95 && props.tipocom === 7) {
              setDepart(4);
              setTip(props.tipo);
              setTicomp(props.tipocom);

              if (props.tipo === 1) {
                setTitulo("Despacho - " + definic + " Solicitud de Donación");
              } else {
                setTitulo(
                  "Presupuesto - " + definic + " Solicitud de Donación"
                );
              }
            }
          }

          /* console.log(props.ubica);
                    console.log(props.tipo);
                    console.log(props.tipocom);
                    console.log(props.devolver); */
        }
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>
            {operacion === 1
              ? titulo
              : operacion === 2
              ? titulo
              : operacion === 3
              ? titulo
              : titulo}
          </h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Dimmer active={activate} inverted></Dimmer>
          <input type="hidden" ref={txtNp} />

          <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded ">
            <legend className="float-none m-0 w-auto">Datos</legend>

            <div className="col-2 m-0 p-0">
                <Input label='Código:'
                    name="observacion"
                    disabled={true}
                    ref={txtCodigo}
                    defaultValue={
                      props.aprobaciones
                        ? props.aprobaciones.idaprobaciones.trim()
                        : ""
                    }
                    id="inputDireccion"
                />
            </div>

            <div className="col-8 m-0 p-0">
              {/* <h3> {tituloapro} </h3> */}
            </div>

            <div className="col-2 m-0 p-0">
                <Input label = 'Fecha:'
                    type="date"
                    disabled={
                      operacion === 4 || operacion === 2 ? true : deshabilitado
                    }
                    defaultValue={
                        props.aprobaciones && props.aprobaciones.fecha !== ""
                        ? moment.utc(props.aprobaciones.fecha).format("YYYY-MM-DD")
                        : moment.utc(fechaSistema).format("YYYY-MM-DD")
                    }
                    id="inputDireccion"
                    ref={txtFecha}
                />
            </div>
            <div className="col-12 m-0 mt-2 p-0">
                <Textarea label = 'Observación'
                    style={{ height: 70 }}
                    name="observacion"
                    onChange={onChange}
                    disabled={
                      operacion === 4 || operacion === 2 ? true : deshabilitado
                    }
                    defaultValue={
                        props.aprobaciones
                        ? props.aprobaciones.observaciones.trim()
                        : ""
                    }
                    placeholder="Descripción de la Observación"
                    id="inputDireccion"
                    ref={txtObservacion}
                />
            </div>
          </fieldset>

          <fieldset className="col-12 m-0 p-2 border-azul rounded">
            <legend className="float-none m-0 w-auto">
              {props.ubica === 90 && props.tipocom === 7
                ? "Detalles del Documento - [IMPUTACIÓN]"
                : props.ubica === 40 && props.tipocom === 0
                ? "Detalles del Documento - [COMPROMISO]"
                : props.devolver === 1
                ? "Detalles del Documento"
                : "Detalles"}
            </legend>
              <TablaDetallesAprobaciones
                data={BaseDatos}
                devolverc={props.devolver}
                ubi={props.ubica}
                tipocom={props.tipocom}
                datarecords={datospre}
                operacion={operacion}
              />
          </fieldset>
      </Modal.Body>
      <Modal.Footer>
        {operacion === 2 ? (
          <InfoButton icon="fa-print">Imprimir</InfoButton>
        ) : (
          <SuccessButton onClick={onChangeValidar} disabled={activo}>
            Aceptar
          </SuccessButton>
        )}
        <DangerButton onClick={cancelar}>Cancealr</DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};
